var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKwe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 94,
    viewBox: "0 0 81 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_270_3597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5008 0L0 23.4996V70.4988L40.5008 94L81 70.4988V23.4996L40.5008 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8115 60.8665L40.4892 78.0621L70.1042 60.8777L40.4892 43.6934L10.8115 60.8665Z",
    fill: "#001A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8115 47.1282L40.4892 64.3239L70.1042 47.1395L40.4892 29.9551L10.8115 47.1282Z",
    fill: "#009F75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4033 20.2293L17.7722 37.4234L10.8523 33.4151L10.8105 33.3893L39.6353 16.7085L40.4882 16.2178L47.4033 20.2293Z",
    fill: "#00EE93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2735 26.5819L28.652 43.7711L21.7354 39.7612L51.3632 22.5703L58.2735 26.5819Z",
    fill: "#00EE93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1049 33.3985L40.4883 50.5845L40.4658 50.5716L33.5459 46.5633L63.169 29.374L70.0824 33.3856L70.1049 33.3985Z",
    fill: "#00EE93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_270_3597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 94,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKwe);
export default __webpack_public_path__ + "static/media/icon-kwe.d6e15c495bec34d0e8de3d0d79fa84e1.svg";
export { ForwardRef as ReactComponent };